import React from "react";
import { MeasurementUnit } from "../../utilities/types/unified-services";

interface UnitToggleProps {
  selectedUnit: MeasurementUnit;
  onUnitChange: (unit: MeasurementUnit) => void;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const UnitToggle: React.FC<UnitToggleProps> = ({ selectedUnit, onUnitChange, size = "md", className = "" }) => {
  const units: MeasurementUnit[] = ["cm", "inch"];

  const sizeClasses = {
    sm: "text-xs px-2 py-1",
    md: "text-sm px-3 py-1.5",
    lg: "text-base px-4 py-2",
  };

  return (
    <div className={`flex items-center justify-center gap-2 p-1 border rounded-full bg-primaryLight/20 border-primary/20 ${className}`}>
      {units.map((unit) => (
        <button
          key={unit}
          onClick={() => onUnitChange(unit)}
          className={`${sizeClasses[size]} rounded-full font-medium transition-all duration-300 ${
            selectedUnit === unit ? "bg-white text-primary shadow-sm" : "text-secondary/70 hover:text-secondary"
          }`}
        >
          {unit.toUpperCase()}
        </button>
      ))}
    </div>
  );
};

export default UnitToggle;
